<template>
  <div
    id="performance-rating"
    class="div-body active"
  >
    <div class="layui-form">
      <h2>绩效管理</h2>
      <form id="performanceRatingForm" class="layui-form">
        <div class="layui-form-item">
          <label class="layui-form-label" style="width: 120px"
            >选择考评部门:</label
          >
          <div class="layui-input-block">
            <a-select
              v-model="currentDept"
              placeholder="请选择考评部门"
              @change="getDeptTable"
              allow-clear
              show-search
              :filter-option="filterOption"
              style="width: 60%"
            >
              <a-select-option
                v-for="item in deptArray"
                :key="item.deptid"
                :value="item.deptid"
                >{{ item.deptname }}</a-select-option
              >
            </a-select>
          </div>
        </div>
        <div class="layui-form-item">
          <label class="layui-form-label" style="width: 120px"
            >选择考评人:</label>
          <div class="layui-input-block">
            <a-select
              placeholder="请选择考评人"
              @change="handleAppraiserChange"
              v-model="currentAppraiser"
              :disabled="!currentDept"
              allow-clear
              show-search
              :filter-option="filterOption"
              style="width: 60%"
            >
              <a-select-option
                v-for="item in departmentUsers"
                :key="item.userid"
                :value="item.userid"
                >{{ item.username }}</a-select-option
              >
            </a-select>
          </div>
        </div>
        <div class="layui-form-item">
          <label class="layui-form-label" style="width: 120px"
            >选择考评年月:</label
          >
          <div class="layui-input-block">
            <a-select
              v-model="selecMonth"
              placeholder="选择考评年月"
              @change="handleMonthChange"
              style="width: 60%"
            >
              <a-select-option
                v-for="month in evMonths"
                :key="month.value"
                :value="month.value"
                >{{ month.text }}</a-select-option
              >
            </a-select>
          </div>
        </div>
        <div class="layui-row">
          <div class="layui-col-sm2 layui-col-md-offset10">
            <a-button type="primary" @click="exportKPI" class="my-button">
              导出本月绩效
            </a-button>
          </div>
        </div>
        <div class="department-performance">
          <h3>部门人员绩效</h3>
          <a-spin :spinning="deptLoading">
            <table class="layui-table">
              <thead>
                <tr>
                  <th class="expand-column" aria-label="展开绩效明细"></th>
                  <th style="width: 24%">姓名</th>
                  <th style="width: 24%">考评年月</th>
                  <th style="width: 23%">考核得分</th>
                  <th style="width: 23%">核准评分</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in departmentPerformanceRows">
                  <tr :key="item.userid">
                    <td class="expand-action-cell">
                      <a-button
                        type="link"
                        size="small"
                        :title="isEmployeeExpanded(item.userid) ? '收起绩效明细' : '展开绩效明细'"
                        @click="toggleEmployeePerformance(item)"
                      >
                        <a-icon :type="isEmployeeExpanded(item.userid) ? 'down' : 'right'" />
                      </a-button>
                    </td>
                    <td>{{ item.username }}</td>
                    <td>{{ item.assessment_period || selecMonth }}</td>
                    <td>{{ formatScore(item.score) }}</td>
                    <td>{{ formatScore(item.approvalscore) }}</td>
                  </tr>
                  <tr
                    v-if="isEmployeeExpanded(item.userid)"
                    :key="item.userid + '-detail'"
                    class="employee-detail-row"
                  >
                  <td colspan="5">
                    <div class="employee-detail-heading">
                      <span>绩效明细</span>
                      <span>{{ item.username }} · {{ item.assessment_period || selecMonth }}</span>
                    </div>
                    <a-spin :spinning="getEmployeeDetail(item.userid).loading" tip="正在加载绩效明细...">
                      <div class="employee-detail-table-wrap">
                        <table class="layui-table employee-detail-table">
                          <thead>
                            <tr>
                              <th style="width: 12%">指标类别</th>
                              <th style="width: 28%">指标名称</th>
                              <th style="width: 32%">计算/评分规则</th>
                              <th style="width: 12%">考核分数</th>
                              <th style="width: 16%">考核得分</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row, index) in getEmployeeDetail(item.userid).rows" :key="index">
                              <td>{{ row.category }}</td>
                              <td>{{ row.description }}</td>
                              <td>{{ row.rule }}</td>
                              <td>{{ formatScore(row.examine_score) }}</td>
                              <td>{{ formatScore(row.score) }}</td>
                            </tr>
                            <tr v-if="!getEmployeeDetail(item.userid).loading && getEmployeeDetail(item.userid).error">
                              <td colspan="5" class="empty-cell detail-error">
                                {{ getEmployeeDetail(item.userid).error }}
                              </td>
                            </tr>
                            <tr v-else-if="!getEmployeeDetail(item.userid).loading && getEmployeeDetail(item.userid).rows.length === 0">
                              <td colspan="5" class="empty-cell">该员工暂无绩效明细</td>
                            </tr>
                            <tr v-if="!getEmployeeDetail(item.userid).loading && hasApprovalScore(item.userid)">
                              <td colspan="4" class="approval-label">核准评分</td>
                              <td class="approval-score">{{ getEmployeeDetail(item.userid).approvalscore }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </a-spin>
                  </td>
                  </tr>
                </template>
                <tr v-if="!deptLoading && departmentPerformanceRows.length === 0">
                  <td colspan="5" class="empty-cell">
                    {{ currentDept ? "该部门暂无绩效数据" : "请先选择考评部门" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </a-spin>
        </div>
      </form>

    </div>

    <div
      id="rating-manage"
      class="div-body"
      style="padding-top: 80px; padding-left: 20px; padding-right: 20px"
    >
      <div class="layui-form">
        <h2>绩效管理</h2>
        <form id="ratingManageForm" class="layui-form"></form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { baseUrl, mockEnabled } from "@/assets/common.js";
// const baseUrl = "https://cim.dingding.sirun.net/";
// const baseUrl = "https://cim-test.dingding.sirun.net/";
const CORP_ID = "ding22edd3ac4f8e7fa8a1320dcb25e91351";
import * as dd from "dingtalk-jsapi";
export default {
  props: {
    globalAccessToken: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      baseUrl,
      //部门
      deptArray: [],
      currentDept: undefined,
      departmentPerformanceRows: [],
      deptLoading: false,
      expandedEmployeeIds: [],
      employeePerformanceDetails: {},
      detailRequestIds: {},
      //当前考核人
      currentAppraiser: undefined,
      rows: [],
      //考评月
      evMonths: [],
      //选中月份
      selecMonth: undefined,
      //当前考核月
      currentMonth: "",
    };
  },
  computed: {
    departmentUsers() {
      return this.departmentPerformanceRows.map((item) => ({
        userid: item.userid,
        username: item.username,
      }));
    },
  },
  watch: {
    globalAccessToken: {
      handler(newVal) {
        if (newVal) {
          this.init();
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.globalAccessToken !== "") {
      this.init();
    }
  },
  methods: {
    async init() {
      this.initializeMonths();
      if (mockEnabled) {
        await this.fetchDepartments();
        return;
      }
      dd.getAuthCode({
        corpId: CORP_ID,
        success: async () => {
          await this.fetchDepartments();
        },
        fail: (err) => {
          console.error("getAuthCode 失败:", err);
        },
        complete: () => {},
      });
    },
    filterOption(input, option) {
      const children = option.componentOptions
        ? option.componentOptions.children
        : option.children;
      const text =
        children && children[0] ? children[0].text || children[0].children : "";
      return String(text).toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    async fetchDepartments() {
      try {
        const response = await axios.get(this.baseUrl + "get_all_departments");
        if (response.status !== 200) {
          throw new Error("获取部门列表失败");
        }
        this.deptArray = Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        this.deptArray = [];
        console.error("未能获取部门列表:", error);
        this.$message.error("部门列表加载失败，请确认部门列表接口已上线");
      }
    },
    initializeMonths() {
      this.evMonths = [];
      const currentDate = new Date();
      let year = currentDate.getFullYear();
      let month = currentDate.getMonth();

      // 如果当前日期在3号之前，则仍然算作上一个月
      if (currentDate.getDate() <= 3) {
        // 如果当前月是1月，则需要回到上一年的12月
        if (month === 0) {
          month = 11; // 12月
          year--; // 年份减1
        } else {
          month--; // 月份减1
        }
      }

      // 生成最近12个月的年月选项（包含往年月份）
      for (let i = 0; i < 12; i++) {
        let targetYear = year;
        let targetMonth = month - i;

        // 处理跨年情况
        while (targetMonth < 0) {
          targetMonth += 12;
          targetYear--;
        }

        const formattedMonth = targetMonth + 1 < 10 ? "0" + (targetMonth + 1) : "" + (targetMonth + 1);
        const yearMonthText = `${targetYear}年${formattedMonth}月`;
        const yearMonthValue = `${targetYear}年${formattedMonth}月`;

        this.evMonths.push({
          text: yearMonthText,
          value: yearMonthValue,
        });
      }

      // 设置默认选中项为当前考核月
      const formattedMonth = month + 1 < 10 ? "0" + (month + 1) : "" + (month + 1);
      this.selecMonth = `${year}年${formattedMonth}月`;
    },
    getTable() {
      if (this.currentAppraiser && this.selecMonth) {
        const employee = this.departmentPerformanceRows.find(
          (item) => item.userid === this.currentAppraiser
        );
        if (employee && !this.isEmployeeExpanded(employee.userid)) {
          this.toggleEmployeePerformance(employee);
        }
      }
    },
    handleAppraiserChange(userid) {
      if (!userid) {
        this.resetEmployeeDetails();
        return;
      }
      this.getTable();
    },
    handleMonthChange() {
      this.getDeptTable();
    },
    async getDeptTable() {
      this.resetEmployeeDetails();
      this.departmentPerformanceRows = [];

      if (!this.currentDept) {
        return;
      }

      this.currentAppraiser = undefined;

      if (!this.selecMonth) {
        this.$message.warning("请先选择考评年月");
        return;
      }

      this.deptLoading = true;
      try {
        const response = await axios.get(
          this.baseUrl + "get_department_performance",
          {
            params: {
              deptid: this.currentDept,
              assessment_period: this.selecMonth,
            },
          }
        );
        if (response.status !== 200) {
          throw new Error("获取部门绩效失败");
        }
        this.departmentPerformanceRows = Array.isArray(response.data)
          ? response.data
          : [];
      } catch (error) {
        console.error("获取部门绩效失败:", error);
        this.$message.error("部门绩效加载失败，请确认按部门查询绩效接口已上线");
      } finally {
        this.deptLoading = false;
      }
    },
    formatScore(score) {
      return score === null || score === undefined || score === ""
        ? "-"
        : score;
    },
    isEmployeeExpanded(userid) {
      return this.expandedEmployeeIds.indexOf(userid) !== -1;
    },
    getEmployeeDetail(userid) {
      return (
        this.employeePerformanceDetails[userid] || {
          loading: false,
          error: "",
          rows: [],
          approvalscore: null,
        }
      );
    },
    hasApprovalScore(userid) {
      const approvalscore = this.getEmployeeDetail(userid).approvalscore;
      return (
        approvalscore !== null &&
        approvalscore !== undefined &&
        approvalscore !== "" &&
        approvalscore !== 0
      );
    },
    resetEmployeeDetails() {
      this.expandedEmployeeIds = [];
      this.employeePerformanceDetails = {};
      Object.keys(this.detailRequestIds).forEach((userid) => {
        this.$set(this.detailRequestIds, userid, this.detailRequestIds[userid] + 1);
      });
    },
    toggleEmployeePerformance(item) {
      const userid = item.userid;
      if (this.isEmployeeExpanded(userid)) {
        this.expandedEmployeeIds = this.expandedEmployeeIds.filter(
          (expandedUserid) => expandedUserid !== userid
        );
        return;
      }

      this.currentAppraiser = item.userid;
      this.expandedEmployeeIds.push(userid);

      const detail = this.getEmployeeDetail(userid);
      if (!this.employeePerformanceDetails[userid] || detail.error) {
        this.fetchAndFillMyPerformanceTable(
          userid,
          item.assessment_period || this.selecMonth
        );
      }
    },
    async fetchAndFillMyPerformanceTable(userid, assessmentPeriod) {
      const requestId = (this.detailRequestIds[userid] || 0) + 1;
      this.$set(this.detailRequestIds, userid, requestId);
      this.$set(this.employeePerformanceDetails, userid, {
        loading: true,
        error: "",
        rows: [],
        approvalscore: null,
      });

      try {
        const params = { userid, assessment_period: assessmentPeriod };
        const [response, res] = await Promise.all([
          axios.get(this.baseUrl + "get_performance_status_data", { params }),
          axios.get(this.baseUrl + "get_approvalscore_data", { params }),
        ]);

        if (requestId !== this.detailRequestIds[userid]) {
          return;
        }

        if (res.status !== 200) {
          throw new Error("网络异常");
        }
        const approvalScore = res.data && res.data.approvalscore;
        const approvalscore =
          approvalScore === null ||
          approvalScore === undefined ||
          approvalScore === ""
            ? null
            : approvalScore;
        if (response.status !== 200) {
          throw new Error("网络异常");
        }
        this.$set(this.employeePerformanceDetails, userid, {
          loading: false,
          error: "",
          rows: !response.data.message && Array.isArray(response.data) ? response.data : [],
          approvalscore,
        });
      } catch (error) {
        if (requestId !== this.detailRequestIds[userid]) {
          return;
        }
        console.error("Error:", error);
        this.$set(this.employeePerformanceDetails, userid, {
          loading: false,
          error: "绩效明细加载失败，请稍后重试",
          rows: [],
          approvalscore: null,
        });
      }
    },
    async exportKPI() {
      if (!this.selecMonth) {
        this.$message.warning("请先选择考评年月");
        return;
      }
      // 直接使用选中的年月，不再拼接年份
      const url =
        this.baseUrl +
        `save_performance_to_excel?assessment_period=${this.selecMonth}`;
      try {
        const response = await axios.get(url);
        const res = response.data;
        if (res.message) {
          this.$message.info(res.message);
          return;
        }
        console.log("save_performance_to_excel", res);
        const downloadLink = document.createElement("a"); // 创建一个 <a> 元素
        downloadLink.href =
          this.baseUrl + "excel/get/" + res; // 设置 <a> 元素的 href 属性为 Blob URL
        downloadLink.download = this.selecMonth + "绩效.xlsx"; // 设置下载文件的文件名
        downloadLink.click();
      } catch (error) {
        console.error("下载失败", error);
        // 处理下载失败的情况
      }
    },
  },
};
</script>

<style scoped>
.div-body {
  padding-top: 80px;
  padding-left: 20px;
  padding-right: 20px;
}
.department-performance {
  margin-top: 24px;
}
.department-performance h3 {
  margin: 0 0 12px;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}
.empty-cell {
  height: 72px;
  color: #999;
  text-align: center;
}
.expand-column,
.expand-action-cell {
  width: 6%;
  padding-right: 4px;
  padding-left: 4px;
  text-align: center;
}
.expand-action-cell .ant-btn {
  color: #677487;
}
.employee-detail-row > td {
  padding: 0;
  background: #f7f9fc;
}
.employee-detail-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 44px;
  padding: 0 16px;
  border-bottom: 1px solid #e8edf3;
  color: #677487;
  font-size: 13px;
}
.employee-detail-heading span:first-child {
  color: #334155;
  font-weight: 600;
}
.employee-detail-table-wrap {
  min-height: 160px;
  max-height: 360px;
  overflow: auto;
}
.employee-detail-table {
  min-width: 720px;
  margin: 0 !important;
}
.approval-label {
  text-align: right;
  font-weight: 600;
}
.approval-score {
  color: #1677ff;
  font-size: 16px;
  font-weight: 600;
}
.detail-error {
  color: #cf1322;
}
.my-button {
  display: inline-block;
  vertical-align: middle;
  height: 38px;
  line-height: 38px;
  border: 1px solid transparent;
  padding: 0 18px;
  background-color: #1e9fff !important;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  font-size: 14px;
  border-radius: 2px;
  cursor: pointer;
}
.my-button-disabled {
  display: inline-block;
  vertical-align: middle;
  height: 38px;
  line-height: 38px;
  border: 1px solid transparent;
  padding: 0 18px;
  white-space: nowrap;
  text-align: center;
  font-size: 14px;
  border-radius: 2px;
}
.my-per-button {
  display: inline-block;
  vertical-align: middle;
  height: 38px;
  line-height: 38px;
  border: 1px solid transparent;
  padding: 0 18px;
  border-color: #16baaa !important;
  color: #16baaa !important;
  background: 0 0;
  white-space: nowrap;
  text-align: center;
  font-size: 14px;
  border-radius: 2px;
  cursor: pointer;
}
</style>
